export default __webpack_public_path__ + "static/media/unsplash_inlyitcs_linkedIn.eb8b3d30.jpg";